import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/*
 * © 2022 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
import { createTheme } from '@mui/system';
import * as COLORS from '../../../styles/colors/colors';
import * as TYPOGRAPHY from '../../../styles/typography/typography';
import * as ELEVATION from '../../../styles/elevation/elevation';
export var ROOT_PREFIX = 'EmbersTableMessage';
export var createTableMessageTheme = function createTableMessageTheme(theme) {
  return createTheme(_objectSpread(_objectSpread({}, theme || {}), {}, {
    components: {
      MuiPaper: {
        styleOverrides: {
          root: _defineProperty({}, "&.".concat(ROOT_PREFIX), {
            '&-root': _objectSpread(_objectSpread({}, ELEVATION.PROMETHEAN_NO_SHADOW), {}, {
              borderRadius: 0,
              padding: '32px 12px',
              '.EmbersStatusIcon-medium .EmbersStatusIcon-text': _objectSpread(_objectSpread({}, TYPOGRAPHY.PROMETHEAN_TYPOGRAPHY_SUBTITLE_01), {}, {
                color: COLORS.PROMETHEAN_TEXT_HEADER
              })
            })
          })
        }
      },
      MuiTypography: {
        styleOverrides: {
          root: _objectSpread(_objectSpread({}, TYPOGRAPHY.PROMETHEAN_TYPOGRAPHY_SUBTITLE_02), {}, {
            marginTop: 32
          })
        }
      }
    }
  }));
};